import type { VenueListFilterSchema } from './schema.ts';
import { FormattedMessage } from 'react-intl';
import { StackedLayout, StackedLayoutSection } from '@_/ui';
import { DistrictFilter } from '#src/components/filters/DistrictFilter.tsx';
import { labelI18n } from '#src/i18nMessages/index.ts';

export function VenueListFilterMenu({
  disabled = false,
  onChange,
  value
}: {
  disabled?: boolean;
  onChange?: (value: VenueListFilterSchema) => void;
  value: VenueListFilterSchema;
}) {
  return (
    <StackedLayout size="sm">
      <StackedLayoutSection heading={<FormattedMessage {...labelI18n.districts} />} initialOpen>
        <DistrictFilter
          disabled={disabled}
          onChange={countryZoneCodes => {
            onChange?.({ ...value, countryZoneCodes });
          }}
          value={value.countryZoneCodes}
        />
      </StackedLayoutSection>
    </StackedLayout>
  );
}
